import { useContext, useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { AccountContext } from "../../contexts/AccountContexts"
import Sidebar from "./sidebar"



export const AdminNavigator = () => {

    const { user } = useContext(AccountContext)
    const navigator = useNavigate()

    useEffect(() => {
        if (user) {
            if (user.class === "user" && user.rank === "user") {
                const predefinedUrl = "/member/home";
                window.location.href = predefinedUrl;
            }
            else if (user.class === "user" && user.rank === "") {
                navigator("/home")
            }
        }


        // else {
        //     navigator(window.location.pathname)
        // }
    }, [])

    return (
        <>
            <Sidebar />
        </>
    )
}